/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdrawconfirmtitle3Inputs */

const en_dropdrawconfirmtitle3 = /** @type {(inputs: Dropdrawconfirmtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run the draw?`)
};

const de_dropdrawconfirmtitle3 = /** @type {(inputs: Dropdrawconfirmtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziehung starten?`)
};

/**
* | output |
* | --- |
* | "Run the draw?" |
*
* @param {Dropdrawconfirmtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdrawconfirmtitle3 = /** @type {((inputs?: Dropdrawconfirmtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdrawconfirmtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdrawconfirmtitle3(inputs)
	return de_dropdrawconfirmtitle3(inputs)
});
export { dropdrawconfirmtitle3 as "dropDrawConfirmTitle" }